<template>
  <div>
    <TopNav/>
    <div class="container mt-4" >
      <h2 class="title">Patient Management</h2>
      <p>Manage and track all patient records</p>
      <div class="card cardCont p-4 pb-0 mb-4">
        <div class="input-group w-100">
          <div class="col-12">
            <div class="input-group w-100"> 
              <input v-model="searchQuery" id="searchQuery" type="text" required  placeholder="search by phone or name" class="form-control" @keyup.enter="searchPhone" />
              <button class="btn btn-primary" @click="searchPatients" :disabled="isLoadingSearch" >
                <span>Search</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="card cardCont px-4 mb-4">
        <div  class="mt-3 w-100">
          <div>
            <h5 v-if="( PatientsResult.length > 0 )">Patients ({{PatientsResult.length }}) </h5>
            <h5 v-else >Patients ({{ totalPatients }}) </h5>
            <p>View and manage all patient information</p>
          </div>
          <!-- Results list -->
          <div v-if="(isSearching ? PatientsResult.length > 0 : patients.length > 0)" class="row">
            <div  v-for="p in (isSearching ? PatientsResult : patients)" :key="p.id"  class=" card col-3 m-2 p-3" style="width: 30%;">
              <div >
                <div class="fw-semibold">
                  {{ p.name }}
                </div>
                <div class="small text-muted">
                  <p>ID: {{ p.id }}</p>
                  <p><i class="fa-solid fa-calendar"></i> {{ p.date_of_birth || 'N/A' }}</p>
                  <p><i class="fa-solid fa-phone"></i>  {{ p.phone_number }}  </p>
                </div>
                <hr>
                <div class="small text-muted">
                  <p>last visit: - <span class="badge rounded-pill bg-light text-dark">{{ p.count }} Encounters</span></p>
                </div>
                <div class="btn-group">
                  <router-link :to="{ name: 'patientDetails', params: { id: p.id} }" class="btn btn-primary btn-sm">
                    <i class="fa-regular fa-eye"></i> View Details
                  </router-link>
                  <button id="btnGroupDrop1" type="button" class="btn btn-outline-secondary dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                    <i class="fa fa-ellipsis-v"></i>
                  </button>
                  <ul class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                    <li><a class="dropdown-item" href="#" @click="openCreateModal(p)"><i class="fa-regular fa-file-lines"></i> New Encounter</a></li>
                    <li><a class="dropdown-item " href="#"  @click="openKortex(p)"><i class="fa-solid fa-wand-magic-sparkles"></i> Kortex </a></li>
                    <hr>
                    <li><a class="dropdown-item" href="#" @click="editPatientModal(p)"><i class="fa-solid fa-pencil"></i> Edit</a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- ============== create new encounter MODAL ============== -->
        <div class="modal fade" id="newEncounterModal" tabindex="-1" ref="createModalRef">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">New Encounter</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body">
                <div class="row">
                  <input class="input-field" type="hidden" required v-model.trim="createForm.id" />
                  <div class="input-group w-50">
                    <label class="input-label">Name</label>
                    <input class="input-field" type="text" required v-model.trim="createForm.name" />
                  </div>
                  <div class="input-group w-50">
                    <label class="input-label">Phone</label>
                    <input class="input-field" type="text" required v-model.trim="createForm.phone_number" />
                  </div>
                  </div>
                <div class="row">
                  <div class="input-group w-50">
                    <label for="DOB" class="input-label">Date of Birth</label>
                    <input v-model="createForm.date_of_birth" id="DOB" type="date" required placeholder="Enter Date of Birth" class="input-field" :disabled="!!selectedPatient"/>
                  </div>
                  <div class="input-group w-50">
                    <label for="DOC" class="input-label">Date of Complaint</label>
                    <input v-model="createForm.DOC" id="DOC" type="date" required placeholder="Enter Date of Complaint" class="input-field" />
                  </div>
                </div>
                <div class="row">
                  <div class="input-group w-50">
                    <label for="DOS" class="input-label">Date of Service</label>
                    <input v-model="DOS" id="DOS"   type="date" required placeholder="Enter Date of Service" class="input-field" />
                  </div>
                  <div class="input-group w-50">
                    <label for="doctorName" class="input-label">Doctor Name</label>
                    <input v-model="doctorName" id="doctorName" type="text" required placeholder="Enter Doctor name" class="input-field" />
                  </div>
                </div>
                <div v-if="saveError" class="alert alert-danger">{{ saveError }}</div>
              </div>
              <div class="modal-footer">
                <button class="btn btn-secondary" data-bs-dismiss="modal" :disabled="isSaving">Cancel</button>
                <button class="btn btn-primary" @click="createNewEncounter" :disabled="isSaving">
                  <span v-if="isSaving">starting...</span>
                  <span v-else>Start</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
        <ul class="pagination mb-4">
          <li class="page-item" :class="{ disabled: currentPage === 1 }">
            <a class="page-link" href="#" @click.prevent="handlePageClick(currentPage - 1)" aria-label="Previous">
              <span aria-hidden="true">&laquo;</span>
            </a>
          </li>
          <li v-for="page in pages" :key="page" class="page-item" :class="{ active: page === currentPage }">
            <a class="page-link" href="#" @click.prevent="handlePageClick(page)">{{ page }}</a>
          </li>
          <li class="page-item" :class="{ disabled: currentPage === totalPages }">
            <a class="page-link" href="#" @click.prevent="handlePageClick(currentPage + 1)" aria-label="Next">
              <span aria-hidden="true">&raquo;</span>
            </a>
          </li>
        </ul>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, nextTick, computed  } from 'vue';
import { useStore } from 'vuex';
import { useRouter} from 'vue-router'; 
import { useToast } from 'vue-toastification';
import JWTinterceptor from '@/services/axios';
import TopNav from '../layouts/topNav.vue';
import Modal from "bootstrap/js/dist/modal";
import { useWebSocket } from '../utils/useWebSocket';
import { useModalManager } from '@/composables/useModalManager'
import EditPatientModal from '@/components/modals/editingPatient.vue'
import { getPatientsService } from "@/services/api/patientService"
import { getNewTopicIdService } from "@/services/api/encounterService"

const { openAsPromise } = useModalManager()
const store = useStore();
const router = useRouter();
const toast = useToast();

const patients = ref([]);
const error = ref(null);
const currentPage = ref(1);
const totalPages = ref(1);
const totalPatients = ref('');
const token = localStorage.getItem('token');
const isSearching = ref(false);
const isLoadingSearch = ref(false);
const searchQuery = ref(''); 
const PatientsResult = ref([]);
const doctorName = localStorage.getItem('username') || ref('');
const DOS = new Date().toISOString().slice(0, 10);
const selectedPatient = ref(null);
const editForm = ref({ name: "", phone_number: "", date_of_birth: "" });
const createForm = ref({ name: "", phone_number: "", date_of_birth: "" , DOC:"", DOS: ""});
const isSaving = ref(false);
const saveError = ref("");
const createModalRef = ref(null);
let createModal;
const webSocket = ref(null);

onMounted(() => { 
  getPatients(currentPage.value); 
});

const getPatients = async (page) => {
  try {
    const response = await getPatientsService(page);
    patients.value = response.data.map(patient => ({
      ...patient,
    }));
    currentPage.value = response.pagination.page;
    totalPages.value = response.pagination.total_pages;
    totalPatients.value = response.pagination.total;
  } catch (err) {
    if (err.response?.status === 401) {
      await getPatients(token, page); 
    }
  }
}
const searchPatients = async () => {
  if (!searchQuery.value) {
    isSearching.value = false;
    await getPatients(currentPage.value);
    return;
  }
  try {
    const response = await JWTinterceptor.get(`${process.env.VUE_APP_SOFA_API}search_patients/${searchQuery.value}`); 
    const searchResult = response.data?.data;
    if (!searchResult || searchResult ===  "No patients") {
          PatientsResult.value = [];
          isSearching.value = true;
    } else {
      PatientsResult.value = searchResult.map(patient => ({
        ...patient,
      }));
      isSearching.value = true;
    }
  } catch (err) {
      error.value = err.message;
      console.error(err.message)
  }
  finally {
    isLoadingSearch.value = false; 
  }
};
const openEditModal = (patient) => {
  selectedPatient.value = { ...patient };
  editForm.value = {
    name: patient.name ?? "",
    phone_number: patient.phone_number ?? "",
    date_of_birth: (patient.date_of_birth ?? "").slice(0, 10),
  };
  saveError.value = "";
};

const editPatientModal = async (patient) => {
  console.log(selectedPatient.value)
  openEditModal(patient); // prepare form

  const result = await openAsPromise({
    component: EditPatientModal,
    props: {
      selectedPatient: selectedPatient.value,
      editForm: editForm.value,
      patientId: patient.id,
    }
  });

  if (result?.updated) {
    getPatients(1);
  }
}

const openCreateModal = (patient) => {
  selectedPatient.value = { ...patient };
  createForm.value = {
    id: patient.id,
    name: patient.name ?? "",
    phone_number: patient.phone_number ?? "",
    date_of_birth: (patient.date_of_birth ?? "").slice(0, 10),
  };
  saveError.value = "";
  if (!createModal) createModal = new Modal(createModalRef.value);
  createModal.show();
}; 
const getNewTopicId = async () => {
  const response = await getNewTopicIdService('');
  return response.id;
};
const createNewEncounter = async () => {
  const topicId = await getNewTopicId();
  if (!topicId) {
    toast.error('Unable to start encounter');
    return;
  }

  if (topicId) {
    const dialogId ="2";
    const patientName = createForm.value.name
    const wsUrl  = `${process.env.VUE_APP_SOFA_WS}${topicId}/${dialogId}/${createForm.value.id}`;

    store.commit('setPatientName', patientName);
    store.commit('setPatientId', createForm.value.id);
    store.commit('setTopicId', topicId);
    store.commit('setDOB',createForm.value.date_of_birth)
    store.commit('setDOC',createForm.value.DOC)
    store.commit('setDOS',DOS)
    
      const data = { topicId, patientName, view: 'record' };
      store.dispatch('navigation/saveNavigationData', data);
      await router.push({ name: 'encounter' });
  if (createModal) createModal.hide();
  await nextTick();
    const handleMessage = (data) => {
      console.log('Message received from WebSocket:', data);
    };
    webSocket.value = useWebSocket(wsUrl, token,handleMessage);
  }
};
const handlePageClick = (pageNum) => {
  if (pageNum !== currentPage.value) {
    console.log(pageNum)
    getPatients(pageNum); 
  }
};
const pages = computed(() => {
  const arr = [];
  if (totalPages.value <= 3) {
    for (let i = 1; i <= totalPages.value; i++) {
      arr.push(i);
    }
  } else {
    if (currentPage.value > 2) arr.push(1, '...');
    for (let i = Math.max(1, currentPage.value - 1); i <= Math.min(totalPages.value, currentPage.value + 1); i++) {
      arr.push(i);
    }
    if (currentPage.value < totalPages.value - 1) arr.push('...', totalPages.value);
  }
  return arr;
});
const openKortex = async (patient) =>{
    const topicId = patient.kortext_url;
    const dialogId ="2";
    const patientId= patient.id
    const patientName= patient.name
    const wsUrl  = `${process.env.VUE_APP_SOFA_WS}${topicId}/${dialogId}/${patientId}`;
    store.commit('setPatientId', patientId);
    store.commit('setTopicId', topicId);
    const ragMode = true;
    const data = {topicId, patientName, ragMode, view: 'encounter' };
    store.dispatch('navigation/saveNavigationData', data);
    await router.push({ name: 'encounter' });
    await nextTick();
    const handleMessage = (data) => {
      console.log('Message received from WebSocket:', data);
    };
    webSocket.value = useWebSocket(wsUrl, token,handleMessage);
}
</script>

<style scoped>
.container{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 5rem;
}
.cardCont{
  width: 75%;
}
.form-check-input:checked {
  background-color: #518db1 !important;
  border-color: #518db1 !important;
}

.title {
  font-weight: 600;
  text-align: center;
  color: #518DB1 ;
}

.input-group {
  margin-bottom: 15px;
  width: 40%;
}

.input-label {
  font-size: 14px;
  margin-bottom: 5px;
  display: block;
  color: #555;
}

.input-field {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 16px;
}

.route-options {
  margin-bottom: 20px;
}

.route-label {
  display: block;
  margin-bottom: 10px;
  font-size: 14px;
  cursor: pointer;
  position: relative;
  padding-left: 15px;
}

.route-radio {
  position: absolute;
}

.modal-actions {
  display: flex;
  justify-content: space-between;
}

.submit-btn {
  flex: 1;
  padding: 10px;
  border: none;
  border-radius: 50px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;
  width: 10rem;
  background-color: #518DB1;
  color: white;
  margin-right: 10px;
}
.input-field{
  border-radius: 8px !important;
}
.addBtn{
  background-color: #FFF
}
.addBtn:hover{
  background-color:#518DB1;
}
@media (max-width: 976px) {
  .card{
    width: 100%;
  }
}

</style>